module.exports = __webpack_public_path__ + "static/media/aap.db9b659a.png";